import { AcceptAssignmentRequestSchema, AcceptAssignmentResponseSchema } from './accept-assignment.schema';
/**
 * Accept Assignment Endpoint Contract
 * Accepts a process step assignment and creates a new recording
 */ export const acceptAssignmentContract = {
    method: 'POST',
    path: '/api/v2/process-step-assignment/:id/accept',
    description: 'Accept a process step assignment and start a new step recording',
    requestSchema: AcceptAssignmentRequestSchema,
    responseSchema: AcceptAssignmentResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Assignment not found or already completed',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user cannot accept this assignment'
        }
    }
};

//# sourceMappingURL=accept-assignment.contract.js.map